module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noUploadPages":"No upload page yet, start by creating one!"},"fr":{"noUploadPages":"Pas de page de téléchargement, commencez par en créer une !"}}')
  delete Component.options._Ctor
}
